<template lang="html">
  <div class="main--box container justify-content-center align-item-center wrap">
<!-- INICIO BOX MENSAGEM ALUNO -->
    <div class="msg--box container">
      <p class="msg--box__firstMsg">
        you finished the session
      </p>

        <p class="msg--box__secondMsg" :class="{ diplaynone: unit.score < 70}">
          Congratulations, you are doing very well. Keep going for good results.
        </p>

        <p class="msg--box__secondMsg" :class="{ diplaynone: unit.score >= 70}">
           Something happened! The rating was below average, you'll be better next time.
        </p>

      <p class="msg--box__unitMsg">
        unit {{ (unit.number < 9) ? '0' + unit.number : unit.number }} <span>is over!</span>
      </p>
    </div>
<!-- FIM BOX MENSAGEM ALUNO -->

<!-- INICIO BOX NOTA ALUNO -->
    <div class="score--box container justify-content-center align-item-center">

        <div class="score--box__style score--box__style__bgGreen container" v-if="unit.score >= 70">
          <div class="score--box__style__msgScore score--box__style__msgScore__msgGreen">
            Your score is good
          </div>
          <div class="score--box__style__numberScore score--box__style__numberScore__numberGreen">
            {{parseFloat(unit.score).toFixed(1)}}
            <span class="score--box__style__numberScore__points">points</span>
            </div>
        </div>

        <div class="score--box__style container score--box__style__bgRed" v-else>
          <div class="score--box__style__msgScore score--box__style__msgScore__msgRed">
            Your score is So So
          </div>
          <div class="score--box__style__numberScore score--box__style__numberScore__numberRed">
            {{parseFloat(unit.score).toFixed(1)}}
            <span class="score--box__style__numberScore__points">points</span>
            </div>
        </div>

      <div class="score--box__actionUser container">

          <a class="score--box__actionUser__btnTry btn margin-right-10" :class="{ diplaynone: unit.score >= 70}">
            Try Again
            <img src="@/assets/img/heart.svg" width="17" alt="Minds" :class="{ disable: unit.life < 1 }">
            <img src="@/assets/img/heart.svg" width="17" alt="Minds" :class="{ disable: unit.life < 2 }">
            <img src="@/assets/img/heart.svg" width="17" alt="Minds" :class="{ disable: unit.life < 3 }">
          </a>

          <a @click="close()" class="score--box__actionUser__btnContinue btn">
            Continue
            <svg class="margin-left-10" xmlns="http://www.w3.org/2000/svg" width="15" height="11.176" viewBox="0 0 14.295 11.176">
              <path id="arrow" data-name="arrow" d="M782.93,481.623l-3.879-4.119a1.4,1.4,0,0,0-.967-.457,1.422,1.422,0,0,0-1.029.365l-.1.1a1.482,1.482,0,0,0,.012,2.01l1.552,1.649h-8.076a1.432,1.432,0,0,0-1.011.451,1.384,1.384,0,0,0-.4.971,1.434,1.434,0,0,0,.386,1.042,1.455,1.455,0,0,0,1.047.464h8.048l-1.568,1.66a1.492,1.492,0,0,0,0,1.994,1.407,1.407,0,0,0,.979.468l.076,0a1.417,1.417,0,0,0,.951-.367l3.97-4.208A1.471,1.471,0,0,0,782.93,481.623Z" transform="translate(-769.038 -477.045)" fill="#fff"/>
            </svg>
          </a>

      </div>

    </div>
<!-- FIM BOX NOTA ALUNO -->
  </div>

  <!-- <div class="modal__content_tp">
    <div class="modal__topic">
      <div class="modal__content__title" :class="{ right: unit.score >= 70, wrong: unit.score < 70 }">
        <p><span>UNIT</span> <b>{{ unit.number }}</b></p>
      </div>
      <svg width="150" class="circular-chart" x="0px" y="0px" viewBox="0 0 36 36" xml:space="preserve">
        <path class="circle2" stroke-dasharray="100, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <path class="circle" :stroke-dasharray="`${unit.score}, 100`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <defs>
          <linearGradient id="MyGradient">
            <stop offset="0%" stop-color="#7F00FD" />
            <stop offset="100%" stop-color="#FFA200" />
          </linearGradient>
        </defs>
      </svg>
      <div class="modal__topic__score">
        <div class="modal__topic__score__fixed">
          <div>
            <span class="modal__topic__score__fixed__title" :class="{ right: unit.score >= 70, wrong: unit.score < 70 }">{{ (parseFloat(unit.score) % 1 !== 0)?parseFloat(unit.score).toFixed(2):unit.score }}</span>
          </div>
        </div>
      </div>
      <div class="modal__topic__button">
        <button @click="close()">{{ (unit.score >= 70) ? 'Finish!' : 'Try again :)' }}</button>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: "SubTopicModal",
  props: {
    unit: {
      type: Object,
      default: []
    },
    close: {
      type: Function,
      default: () => console.log('Close Event!')
    }
  }
}
</script>

<style lang="scss" scoped>
  // Ajustes de classe
.disable {
  filter: grayscale(100%);
}
.normal {
  filter: none;
}
.diplaynone{
  display: none!important;
}
// Fim de Ajustes de classe

  .main--box{
    width: 100%;
    height: 100%;
    border-radius: 25px;
    padding: 35px 20px;
    background: linear-gradient(#ebce00 0%, #ff5700 100%);

// ### INICIO MSG BOX
    .msg--box{
      // background: #ff5700;
      flex-grow: 1;
      flex-basis: 50%;
      flex-direction: column;
      text-align: end;
      justify-content: space-evenly;

      &__firstMsg{
        font-size: 65px;
        line-height: .9em;
        color: white;
        font-weight: 400;
        text-transform: uppercase;
        }
      &__secondMsg{
        font-size: 20px;
        // line-height: 1.1px;
        color: #821010;
        font-weight: 200;
        padding-left: 30px;
        }
      &__unitMsg{
        font-size: 45px;
        // line-height: 1.1px;
        color: #821010;
        font-weight: 400;
        text-transform: uppercase;
        span{
          color: #460808;
        }
        }
    }
// ### FIM MSG BOX

// ### INICIO BOX SCORE
      .score--box{
        flex-grow: 1;
        flex-basis: 50%;
        flex-direction: column;
        padding: 0px 40px;

        &__style{
          padding: 10px;
          justify-content: center;
          align-items: center;
          border-radius: 25px;

          &__bgGreen {
           background: linear-gradient(#0af1e9 0%, #fff12d 100%);
            }

          &__bgRed {
           background: linear-gradient(0deg, #ff4747 4.18%, #c53030 100%);
            }

          &__msgScore{
            width: 120px;
            font-size: 30px;
            // margin: 0px 10px 0px 0px;
            // padding: 0px 0px 0px 70px;
            line-height: .9;
            text-align: end;
            text-transform: uppercase;
            &__msgGreen{
              color: #006B50;
            }
            &__msgRed{
              color: #6A0000;
            }
          }

          &__numberScore{
            font-size: 80px;
            padding: 25px;
            margin: 20px 0px 20px 20px;
            color: #09A57E;
            background: white;
            border-radius: 25px;
            position: relative;
            &__numberGreen{
              color: #006B50;
            }
            &__numberRed{
              color: #6A0000;
            }

            &__points{
              background: #ffb200;
              width: 60px;
              padding: 6px;
              font-size: 10px;
              color: darkred;
              position: absolute;
              top: calc(100% - 27px);
              left: calc(100% - 60px);
              border-radius: 90px 0px;
              border: 2px solid white;
              text-align: center;
              }
            }
         }
        &__actionUser{
          // flex-direction: row;

          a{
            font-size: 17px!important;
            font-weight: 400;
            flex-grow: 1;
            // letter-spacing: .7px;
            text-transform: uppercase;
            margin-top: 15px;
            border-radius: 50px;
            img{
               margin-left: 3.5px;
            }
          }
          &__btnContinue{
              background: linear-gradient(90deg, #00b0ea 0%, #4a70fe 100%);
              color: white;
              img{
                color: white;
                background: white;
              }
              }
          &__btnTry{
              background: rgb(255, 187, 0);
              color: #C83041;
              }
          }
        }
  // ### FIM BOX SCORE
    }


// .modal__content_tp {
//   height: 100%;
//   width: 100%;
//   display: flex;
//   flex-direction: row;
//   .modal__content__title {
//     text-align: center;
//     position: absolute;
//     z-index: 15;
//     width: 100%;
//     height: 100%;
//     color: #444;
//     font-size: 36px;
//   }
//   .modal__topic {
//     display: flex;
//     flex-direction: row;
//     flex-basis: 100%;
//     justify-content: center;
//     text-align: center;
//     position: relative;
//     flex-direction: column;
//     .modal__topic__score {
//       height: 100%;
//       width: 100%;
//       position: absolute;
//       display: inline-block;
//       .modal__topic__score__fixed {
//         width: 100%;
//         height: 100%;
//         display: flex;
//         justify-content: center;
//         font-weight: 600;
//         font-size: 46px;
//         color: #555;
//         position: absolute;
//         z-index: 15;
//         div {
//           height: 50px;
//           transform: translateY(200%);
//           .modal__topic__score__fixed__title {
//             display: inline-block;
//             vertical-align: middle;
//           }
//         }
//       }
//     }
//     .modal__topic__button {
//       margin-top: 20px;
//       display: flex;
//       flex-direction: row;
//       justify-content: center;
//       text-align: center;
//       button {
//         background: linear-gradient(to top, #F07900, #FFB500) !important;
//         width: 200px;
//         height: 50px;
//         border-radius: 150px;
//         border: none;
//         text-transform: capitalize;
//         z-index: 20;
//         &:hover {
//           background: linear-gradient(to top, #cc6600, #d19400) !important;
//           cursor: pointer;
//         }
//       }
//     }
//   }
//   .right {
//     color: #09ba00;
//   }
//   .wrong {
//     color: #ce1400;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/modal/modalUnit.vue